import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/pages',
        endpoints: {
            '/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '/news_post/.+/categories': {
                params: { filter: '' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            // '/orders': {
            //     params: { sort: 'order_date:desc' }
            // },
            // '/customers': {
            //     params: { filter: 'registered:1' }
            // },
            '/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '/subscribers': {
                params: { sort: 'created_at:desc' }
            },
            '^/downloads': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
